import { Formik } from 'formik';
import React, { useState } from 'react';
import { Fieldset } from '~/components/FormControl';
import { schema } from './characterClassSkin.yup';
import { Card, Button } from 'react-bootstrap';
import { titleCase } from '~/utils/helpers';
// import DisplayFormikState from '~/components/DisplayFormikState/DisplayFormikState';
import { useDispatch, useSelector } from 'react-redux';
import SkinItem from './SkinItem';
import PreviewAsImg from '~/components/FileUploaded/picture-preview/PreviewAsImg';
import { IMG_HEIGHT, IMG_WIDTH } from '~/config/constants';
import SkinUpdate from './SkinUpdate';
import SkinForm from './SkinForm';
import { deleteCharacterClassSkinApi, storeCharacterClassSkinApi } from './characterClassSkinSlice';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

function CharacterClassSkin() {
    const { skins } = useSelector((state) => state.cardSaga.characterClassSkin);
    const { id: characterClassId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [resetCount, setResetCount] = React.useState(0);

    const onSubmit = async (rawValues, { resetForm }) => {
        try {
            dispatch(storeCharacterClassSkinApi({ characterClassId, navigate, rawValues, resetForm, setResetCount }));
        } catch (err) {
            console.log(err);
        }
    };

    const [edit, setEdit] = useState(false);
    const [editedSkin, setEditedSkin] = useState({});

    return (
        <Card>
            <Card.Body>
                {/**************** {'SKIN ADDED FORM'} ****************/}
                <Formik
                    initialValues={{
                        name: '',
                        rarity: '',
                        size: '',
                        image: '',
                    }}
                    validateOnChange={false}
                    validationSchema={schema(true, 1024 * 1024 * 20)} // largest size I noticed for the skin is 17MB
                    // validator={() => ({})} //this prop will not trigger validation errors. Refs: https://stackoverflow.com/a/58141871/11297747
                    onSubmit={onSubmit}
                >
                    {(props) => {
                        // eslint-disable-next-line react/prop-types
                        const { isSubmitting, handleSubmit, values } = props;

                        return (
                            <>
                                <Fieldset
                                    sm={4}
                                    fieldsetStyle={{ margin: '0 auto' }}
                                >
                                    <Fieldset.Legend>Skin Upload</Fieldset.Legend>
                                    <Button
                                        disabled={isSubmitting}
                                        as="input"
                                        type="submit"
                                        value={isSubmitting ? 'Submitting...' : 'Submit'}
                                        onClick={handleSubmit}
                                        className={'ml-auto bg-info border border-info'}
                                    ></Button>
                                    <SkinForm
                                        values={values}
                                        resetCount={resetCount}
                                    />
                                </Fieldset>
                                {/* <DisplayFormikState props={props} /> */}
                            </>
                        );
                    }}
                </Formik>

                {/**************** {'SKIN COLLECTION'} ****************/}
                <div
                    className="d-flex align-items-center"
                    style={{ flexWrap: 'wrap' }}
                    id="skinAddedForm"
                >
                    {skins.map((skin, i) => {
                        return (
                            <SkinItem key={i}>
                                <PreviewAsImg
                                    pictureUrl={
                                        skin.image instanceof File ? URL.createObjectURL(skin.image) : skin.image
                                    }
                                    width={skin.size === 'normal' ? parseFloat(IMG_WIDTH) : parseFloat(IMG_WIDTH) * 1.5}
                                    height={
                                        skin.size === 'normal' ? parseFloat(IMG_HEIGHT) : parseFloat(IMG_HEIGHT) * 1.5
                                    }
                                />
                                <div>ID: {skin.id}</div>
                                <div>Name: {skin.name}</div>
                                <div>Rarity: {titleCase(skin.rarity)}</div>
                                <div className="d-flex mt-2">
                                    <Button
                                        onClick={() => {
                                            setEditedSkin(skin);
                                            setEdit(true);
                                        }}
                                        className={'bg-info border border-info'}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            MySwal.fire({
                                                title: 'Are you sure?',
                                                text: "You won't be able to revert this!",
                                                icon: 'warning',
                                                confirmButtonColor: '#d33',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    dispatch(
                                                        deleteCharacterClassSkinApi({
                                                            characterClassId,
                                                            characterClassSkinId: skin.id,
                                                            navigate,
                                                        }),
                                                    );
                                                }
                                            });
                                        }}
                                        className={'bg-danger border border-danger ml-auto'}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </SkinItem>
                        );
                    })}
                </div>

                <SkinUpdate
                    edit={edit}
                    setEdit={setEdit}
                    editedSkin={editedSkin}
                />
            </Card.Body>
        </Card>
    );
}

export default CharacterClassSkin;
